import { createFileRoute } from '@tanstack/react-router'
import { SavedPage } from '../components/pages'
import { noIndexRouteHead } from '../lib/seo'

export const Route = createFileRoute('/it/salvati')({
  head: () => noIndexRouteHead('saved', 'it'),
  component: SavedPage,
})
